import {OtsUIState} from "../../ots-ui-store";

export const selectUIMeterFlowVolumeSearchFilter = (state: OtsUIState) => state.uiMeterFlowVolume.searchFilter
